import React from "react";
import { IntegrationProps } from "../../pages/ApplicationDetailsPage";

export class ZoomIntegration extends React.Component<IntegrationProps, {}> {
  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleMessage = (event: any) => {
  };
  render() {
    return (
      <>
        <iframe title="Zoom Link" src={this.props.integration.url} width="100%" height="1000px"></iframe>
      </>
    );
  }
}